import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye, X } from "lucide-react";
import { AdminLogger } from "@/lib/adminLogger";

export function ImpersonationBanner() {
  const { impersonatedUser, isImpersonating, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedUser) return null;

  const handleStop = () => {
    AdminLogger.impersonationStop(impersonatedUser.id, impersonatedUser.email);
    stopImpersonation();
    navigate("/admin/users");
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground px-4 py-2 flex items-center justify-center gap-3 text-sm shadow-md">
      <Eye className="h-4 w-4 shrink-0" />
      <span>
        Viewing as <strong>{impersonatedUser.email}</strong>
        {impersonatedUser.roles.length > 0 && (
          <span className="ml-1 opacity-80">
            ({impersonatedUser.roles.join(", ")})
          </span>
        )}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={handleStop}
        className="ml-2 h-7 bg-destructive-foreground/10 border-destructive-foreground/30 text-destructive-foreground hover:bg-destructive-foreground/20"
      >
        <X className="h-3 w-3 mr-1" />
        Stop Impersonating
      </Button>
    </div>
  );
}
